import { render } from "./PaymentCancel.vue?vue&type=template&id=b3676f1c&scoped=true"
import script from "./PaymentCancel.vue?vue&type=script&lang=js"
export * from "./PaymentCancel.vue?vue&type=script&lang=js"

import "./PaymentCancel.vue?vue&type=style&index=0&id=b3676f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3676f1c"]])

export default __exports__